<template>
  <div class="city-list">
    <div slot="bread">
</div>
    <list-page-header :page-info="pageInfo">
     <div slot="bread">
   <router-link :to="{ name: 'home' }" class="color-white mytitle">Yurtlarburada.com</router-link><span class="mytitle"> / </span>
</div>
      <div class="hero-search__left">
        <div class="hero-search__select fw">
          <v-select :options="city" placeholder="Şehir Seçiniz" @onselect="selectCity"/>
        </div>
      </div>
      <v-link
        :to="searchUrl"
        class="hero-search__submit green"
        icon="icon-search"
        icon-position="left"
        title="YURT ARA"
        @click.native="selectCity"
      />
    </list-page-header>    
    <div class="city-list__inner">     
      <container>
        <div class="section__title fw text-center"><span class="color-light-green">Popüler</span> Şehirler</div>
      <ContentLoader v-if="!featuredCities && !mobileCheck"
      :height="500">
        <rect x="2" y="0" rx="3" ry="3" width="195" height="70" />
        <rect x="202" y="0" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="0" rx="3" ry="3" width="95" height="70" />

        <rect x="2" y="75" rx="3" ry="3" width="95" height="70" />
        <rect x="103" y="75" rx="3" ry="3" width="95" height="70" /> 
        <rect x="202" y="75" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="75" rx="3" ry="3" width="95" height="70" />       
      </ContentLoader>
      <ContentLoader v-if="!featuredCities && mobileCheck"
      :height="400">
        <rect x="2" y="0" rx="3" ry="3" width="400" height="400"/>     
      </ContentLoader>      
        <div class="city-list__list">
          <div
            v-for="(city, $index) in featuredCities"
            :key="city.id"
            class="city-list__col"
            :class="[$index === 0 ? 'col-xl-6 col-lg-6 col-md-6' : 'col-xl-3 col-lg-3 col-md-3']">
            <CityCard
              :city="city"
            />
          </div>
        </div>

        <div class="city-list-result">
          <div class="result-bracket">
            <div class="result-bracket__title">
              <span class="result-bracket__count" v-if="cities">{{ cities.length }}</span> Şehir Bulunuyor!
            </div>
          </div>
      <ContentLoader v-if="!cities && !mobileCheck"
      :height="400">>
        <p>&nbsp;</p>
        <rect x="2" y="0" rx="3" ry="3" width="95" height="70" />
        <rect x="103" y="0" rx="3" ry="3" width="95" height="70" />
        <rect x="202" y="0" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="0" rx="3" ry="3" width="95" height="70" />

        <rect x="2" y="75" rx="3" ry="3" width="95" height="70" />
        <rect x="103" y="75" rx="3" ry="3" width="95" height="70" /> 
        <rect x="202" y="75" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="75" rx="3" ry="3" width="95" height="70" />

        <rect x="2" y="150" rx="3" ry="3" width="95" height="70" />
        <rect x="103" y="150" rx="3" ry="3" width="95" height="70" /> 
        <rect x="202" y="150" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="150" rx="3" ry="3" width="95" height="70" />

        <rect x="2" y="225" rx="3" ry="3" width="95" height="70" />
        <rect x="103" y="225" rx="3" ry="3" width="95" height="70" /> 
        <rect x="202" y="225" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="225" rx="3" ry="3" width="95" height="70" />           
      </ContentLoader>

      <ContentLoader v-if="!cities && mobileCheck">
        <rect x="3" y="0" rx="3" ry="3" width="376" height="440" />      
      </ContentLoader>

          <div class="city-list-result__list flex-row">
            <div class="city-list-result__item col-xl-3 col-md-4"
                 v-for="city in cities"
                 :key="city.id">
              <router-link :to="{ name: 'City', params: { id: city.id, city: city.slug }}" @click.native="onSelect()">
                <CityInfoCard
                  :city="city"
                />
              </router-link>
            </div>

            <!--<div class="city-list-result__bottom fw text-center">-->
              <!--<v-link-->
                <!--to="/yurtlar"-->
                <!--class="button&#45;&#45;stroke round icon-transform"-->
                <!--title="Daha Fazla Gör"-->
                <!--icon="icon-arrow-long-right"-->
                <!--icon-position="right"-->
              <!--/>-->
            <!--</div>-->
          </div>
        </div>
      </container>
    </div>
  </div>
</template>

<script>
import ListPageHeader from '@/components/ListPageHeader'
import CityCard from '@/components/CityCard'
import CityInfoCard from '@/components/CityInfoCard'
import { ContentLoader } from 'vue-content-loader'
import axios from 'axios'
export default {
  name: 'CityList',
  components: {
    ListPageHeader, CityCard, CityInfoCard, ContentLoader
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Şehirler',
       meta: [
         { vmid: 'description', name: 'description', content: this.pageInfo.text },
         { vmid: 'keywords', name: 'keywords', content: 'öğrenci yurdu, istanbul öğrenci apartları, izmir yurtları, ankara özel yurtlar ,istanbul yurtlar, yurtlarburada, yurt ara' }
       ],
       link: [
         { vmid: 'canonical', rel: 'canonical', href: window.location.origin + '/sehirler' }
       ]      
    }
  },  
  data () {
    return {
      pageInfo: {
        icon: require('@/assets/img/icon-city.svg'),
        title: '<span class="color-light-green">Şehrindeki </span> Yurtlar Burada!',
        text: 'Şehrindeki tüm yurtları bulabilir, yurtlar hakkında bilgi alabilir, yurtlarla iletişime geçerek oda fiyatlarını öğrenebilirsin!'
      },
      city: [],
      cityID: null,
      featuredCities: null,
      cities: null,
      searchUrl: {}
    }
  },
  methods: {
    onSelect () {
      // console.log(opt)
      window.localStorage.setItem('district_name', '')
    },
    selectCity (opt) {
      // this.cityID = opt.id
      // this.searchUrl = { name: 'City', params: { slug: opt.slug, id: opt.id } }
      // console.log("sehir: " + this.$refs.myinput.value)
      // const selectedCity = this.$refs.myinput.value
      // let mycity = this.city.find(function (citty) { return citty.name == selectedCity } )
      // let slug = this.string_to_slug(this.$refs.myinput.value)
      window.localStorage.setItem('district_name', '')
      this.$router.push({ name: 'City', params: { city: opt.slug, id: opt.id } })
    },
    getPopularCities () {
      let self = this
      axios.get('/site/home/cities?take=7')
        .then(response => {
          self.featuredCities = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    getCityList () {
      let self = this
      axios.get('/site/cities/cities')
        .then(response => {
          self.cities = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    getCities () {
      let self = this
      axios.get('/site/home/select-cities')
        .then(response => {
           self.city = response.data
/*          response.data.forEach(function(element) {
          self.city.push(element.name)
         })      */
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  created () {
    this.getPopularCities()
    this.getCities()
    this.getCityList()
  },
  computed: {
    mobileCheck() {
     var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check
  },     
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/components/city-list";
</style>
